module.exports = __webpack_public_path__ + "media/sora_realistic_motion.b4b5c963.mp4";